import { Color } from '@diritto/common/style/color';
import { buildUrl } from '@diritto/common/utils/urls';
import styled from '@emotion/styled';
import { PencilIcon } from 'icons/PencilIcon';
import React from 'react';
import { Link } from 'ui-components/common/Link';

export const RollingAddButton = ({ contentId }: { contentId?: number }) => (
  <StyledRollingAdd href={buildUrl(`/rollings/add`, { contentId: contentId ? String(contentId) : undefined })}>
    <PencilIcon className="size-[24px]" />
  </StyledRollingAdd>
);

const StyledRollingAdd = styled(Link)`
  width: 48px;
  height: 48px;
  padding: 12px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 64px;
  background-color: ${Color.Primary500};
`;
